var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status)?_c('v-card-text',{class:_vm.statusClass},[_vm._v(_vm._s(_vm.statusText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }